import variables from '../../scss/utilities/derived-variables.scss'

export const getColorByTheme = (type) => {
  return variables[type]
}
